import axiosInstance from ".";

export const fetchPlans = () =>
  axiosInstance.get(`/v1/plans/active`);



